export default __webpack_public_path__ + "img/my-logo.0f6511b3.png";